<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon icon-content"
              >
                <font-awesome-icon icon="dollar-sign" />
              </span>
            </template>
            <h3>{{ detailData.file_name }} - {{detailData.ext}}</h3>
          </div>
          <div class="mg-b-8">

            <span class="header-date">Created  <span class="number-color number-fontsize">{{ detailData.created_at }}</span></span>
            <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_at }}</span></span>
          </div>
          <div class="mg-b-20">
            <span class="header-date">Reference <span class="number-color number-fontsize">{{detailData.reference_number}}</span></span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!edit"
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">
          <div class="detail ">
            <div class="detail_title flex-sb-center">
              <span>Details</span>
            </div>
            <div
              v-if="detailData.status==2"
              class="table status-table table-only-th">
              <div class="th flex-sb-center">
                <span class="flex-align-center">
                  <span>Weekly Selection</span>
                  <span
                    class="icon-width"
                  >
                    <img src="@/assets/images/icon/star-solid.svg">
                  </span></span>
                <span class="text-right">
                  <v-text-switch
                    v-model="weekly"
                    @change="handleWeekly"></v-text-switch>
                </span>
              </div>
            </div>
            <div class="table status-table">
              <div class="th">
                <span>Car bomb</span>
                <span
                  class="span-status mg-l-10"
                  :class="{
                    'blue':[3].includes(detailData.status),
                    'orange':[1].includes(detailData.status),
                    'green':[2].includes(detailData.status),
                    'dark':[4].includes(detailData.status),
                  }"
                >
                  {{getOptionName('carbombStatutList',detailData.status)}}
                </span>
              </div>
              <div class="tr">
                <span class="fw-600">
                  <p>MP4</p>
                  <span class="fw-400 gray">{{detailData.file_size}}</span>
                </span>
                <span class=""><v-button
                  gray
                  icon="download"
                  @click="handleDown(detailData.file_url)">
                  Download
                </v-button></span>
              </div>
              <div class="tr">
                <span class="fw-600">Message</span>
                <span class="">{{detailData.message||'-'}}</span>
              </div>
              <div class="tr">
                <span class="fw-600">Rewarded Hold Dollars</span>
                <span class="">{{detailData.reward||'-'}}</span>
              </div>
              <!--              <div-->
              <!--                v-for="(item,index) in detailData.stts_update_data"-->
              <!--                :key="index"-->
              <!--                class="tr">-->
              <!--                <span>-->
              <!--                  <p class="fw-600">{{item.stts_language}}</p>-->
              <!--                  <p class="fw-400 fs-12">{{item.desc}}</p>-->
              <!--                </span>-->
              <!--                <span>{{item.updated_date||'-'}}</span>-->
              <!--              </div>-->
            </div>
            <div class="table">
              <div class="th flex-sb-center">
                <span>
                  Published Youtube
                </span>
                <span
                  class="hand blue"
                  @click="handleEdit">Edit</span>
              </div>
              <div class="tr">
                <span class="fw-600">Registration No.</span>
                <span class="">{{detailData.registration_no||'-'}}</span>
              </div>
              <div class="tr">
                <span class="fw-600">Title</span>
                <span class="">{{detailData.title||'-'}}</span>
              </div>
              <div class="tr flex-no-algin">
                <span class="fw-600 width-50">
                  <p>Youtube Link</p>
                  <a
                    v-if="detailData.link"
                    class="fw-400 text-decoration-none width-45 blue"
                    target="_blank"
                    :href="detailData.link">
                    {{detailData.link}}
                  </a>
                </span>
                <span>
                  <iframe
                    v-if="detailData.link"
                    width="237"
                    height="142"
                    class="video-border"
                    :src="detailData.link"
                    frameborder="0"
                    allow="accelerometer"
                  ></iframe>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="tr ">
                <span class="fw-600">Bomb Rating</span>
                <span class="">{{detailData.bomb_rating}}</span>
              </div>
            </div>
            <div class="table">
              <div class="th">
                Account Name
              </div>
              <!--              <div class="tr">-->
              <!--                <span class="fw-600">Last Name</span>-->
              <!--                <span>{{detailData.isrd_lst_nm}}</span>-->
              <!--              </div>-->
              <!--              <div class="tr">-->
              <!--                <span class="fw-600">First Name</span>-->
              <!--                <span>{{detailData.isrd_fst_nm}}</span>-->
              <!--              </div>-->
              <div class="tr">
                <span class="fw-600">Mobile Number</span>
                <span>{{detailData.mobile_no}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-col">
          <div class="">
            <div
              class="btn-list "
            >
              <span
                class="title">Support</span>
              <div
                class="button-width mg-t-8">
                <span  class="mg-t-15 block">
                  <v-button
                    green
                    @click="handleUpdateStatus"
                  >
                    <span>Update Status</span>
                  </v-button>
                </span>
                <span  class="mg-t-15 block">
                  <v-button
                    gray
                    class="mg-t-15"
                    @click="handleBack"
                  >
                    <span>Back</span>
                  </v-button>
                </span>
              </div>
            </div>
            <div
              class="box">
              <span class="title">Customer</span>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{customer_profile.id_type==3?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customerId}}"
                    class="flex flex-wrap text-decoration-none">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                    >{{ customer_profile.isrd_nm }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                    >Unnamed Account &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ customer_profile.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ customer_profile.policys }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="customer_profile.id"
                :phone="customer_profile.phone"
                :customerName="detailData.isrd_nm"
                :email="customer_profile.send_email" />
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <car-bomb-form
      v-else
      :id="id"
      :from="detailData"
      :remark="remarkList"
      @success="handleRefresh"
      @cancel="edit = false"></car-bomb-form>
    <update-dialog
      v-model="showUpdate"
      :form="detailData"
      @refresh="handleRefresh"></update-dialog>
  </section>
</template>

<script>
import {getCarbombDetail, addCarbombRemark, editCarbomb} from '@/api/car-bomb'
import MixinOptions from '@/mixins/options'
import ContactCustomer from '@/views/components/new-contact-customer'
import UpdateDialog from '@/views/records/micropolicy/components/car-bomb/updateDialog'
import CarBombForm from '@/views/records/micropolicy/components/car-bomb/car-bomb-form'
import {addAccountRemark, getAccountDetail} from '@api/account'
export default {
  name: 'CarBombDetail',
  components:{
    ContactCustomer,
    UpdateDialog,
    CarBombForm
  },
  mixins: [MixinOptions],
  data () {
    return {
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      edit:false,
      showUpdate:false,
      customer_profile:{},
      weekly:0
    }
  },
  computed:{
    id(){
      return this.$route.params.id
    },
    isShowName(){
      let {isrd_nm,id_type} = this.customer_profile
      if(isrd_nm)
        return isrd_nm.trim()!=''
      else return  false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    selectData(){
      return [this.id]
    },
    customerId(){
      let {user_id} = this.detailData||{}
      return user_id||''
    },
    avt_pic(){
      let {avatar_pic} = this.customer_profile||{}
      return avatar_pic || null
    },
  },
  watch:{
    id:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getCarbombDetail()
        }
      }
    },
    customerId:{
      immediate:true.value,
      handler(val){
        if(val)
          this.network().getAccountDetail()
      }
    }
  },
  methods: {
    handleDown(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    handleClaim(){
      this.showClaim = true
    },
    handleBack(){
      this.$router.back()
    },
    handleUpdateStatus(){
      this.showUpdate = true
    },
    handleEdit(){
      this.edit = true
    },
    handleRefresh(){
      this.edit = false
      this.network().getCarbombDetail()
    },
    handlerSendRemark(){
      if(this.message){
        this.network().addAccountRemark()
      }
    },
    handleWeekly(){
      this.network().editCarbomb()
    },
    network(){
      return{
        editCarbomb: async (params) => {
          const { data } = await editCarbomb({
            id: this.id,
            weekly:this.weekly
          })
        },
        getCarbombDetail: async () => {
          const {data} = await getCarbombDetail({
            id: this.id
          })
          this.detailData = data.data
          let {weekly} = this.detailData||{}
          this.weekly = weekly||0
        },
        addAccountRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.customerId,
            message: this.message
          })
          this.message = ''
          // todo 追加 remark
          this.remarkList.unshift(data)
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.customerId
          })
          this.customer_profile = data.customer_profile
          this.remarkList = data.remark
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../../assets/css/pay-main-header';
@import '../../../../../assets/css/mic-detail';
.icon-width{
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-left: 7px;
}
.video-border{
  border-radius: 8px;
}
.width-50{
  width: 50%;
}
.width-45{
  width: 45%;
  //word-break: break-word;
}
.flex-no-algin{
  align-items: start!important;
}
</style>
